import type { App } from 'vue';
import VueZoomer from 'vue-zoomer';

export function bootVueZoomer({ app }: { app: App<Element> }): void {
	app.use(VueZoomer);
}
